import React, { Component } from 'react';
import { getDropdownList } from '../data/countries';
import { getLanguageList } from '../data/languages';
import { withRouter } from 'react-router';

export const countries = getDropdownList();
export const languageList = getLanguageList();

const defaultValue = 'Select your language';
class LanguageDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      dropdownValue: defaultValue
    };

    this.selectLanguage = this.selectLanguage.bind(this);
    this.clearDropdown = this.clearDropdown.bind(this);

    this.componentRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('click', this.clickOutside);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      // console.log('sdsd')
      // const dropdownValue = languageList.filter(lang => lang.id === this.props.match.params.id);
      // if(dropdownValue.length === 0) {
      //   dropdownValue.push({name: 'English'})
      // }
      // this.setState({ dropdownValue: dropdownValue.name });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickOutside);
  }

  setWrapperRef = (node) => {
    this.componentRef = node;
  }

  selectLanguage(event) {
    const language = event.target.value;
    // const dropdownValue = languageList.filter(lang => lang.id === language);
    // this.setState({ dropdownValue: dropdownValue.name});
    this.props.history.push(language === '0' ? this.props.url : this.props.url + language);
  }

  selectLanguageDropdown(evt, language) {
    evt.stopPropagation();
    this.props.history.push(language === '0' ? this.props.url : this.props.url + language);
    this.close();
  }

  clearDropdown(evt) {
    evt.stopPropagation();
    this.props.history.push(this.props.url);
    this.setState({ dropdownValue: defaultValue });
  }

  openList = () => {
    this.setState({ listOpen: true });
  }
  
  clickOutside = (event) => {
    if (this.componentRef && !this.componentRef.contains(event.target)) {
      this.close();
    }
  }

  close = () => {
    this.setState({
      listOpen: false
    });
  }

  /**
   * Renders the closed dropdown selection
   */
  renderLabel = () => {
    if (!this.props.match.params.id) {
      return <span>Select your language</span>
    }
    const defaultFallback = { id: "en", name: "English" };
    const country = languageList.find(({ id }) => { return id === this.props.match.params.id }) || defaultFallback;

    return <div className="platform-wrapper">
      <div className="platform-info">
        <span className="selected-item-title">{country.name}</span>
      </div>
      <span className="close-icon" readOnly onClick={(evt) => this.clearDropdown(evt)} ></span>
    </div>;
  }

  render() {
    const selected = this.props.match.params.id ? 'selected' : '';
    const { listOpen } = this.state;
    return (
      <>
        <div className={`hide-mobile dropdown language-dropdown ${this.props.match.params.id ? 'selected' : ''}`} onClick={this.openList} ref={this.setWrapperRef}>
        {this.renderLabel()}

        {listOpen && (
          <div className="dropdown-list">
            <div className="dropdown-list-wrapper">
              <ul>
                {
                  languageList.map(language => (
                    <li onClick={(evt) => this.selectLanguageDropdown(evt, language.id)} key={language.id}>
                      <p  key="0" className="country-name">{language.name}</p>
                    </li>
                    )
                  )
                }
              </ul>
            </div>
          </div>
        )}
      </div>

      <div className={`dropdown hide-tablets-desktop language-dropdown ${selected}`}>
        <select ref={this.selectRef}  className='mobile-select' onChange={this.selectLanguage}>
          <option value="0">{defaultValue}</option>
          {
              languageList.map(language => <option key={language.id} selected={language.id === this.props.match.params.id ? 'selected' : '' } value={language.id}>{language.name}</option>)
          }
        </select>
        <span className="close-icon" readOnly onClick={this.clearDropdown} ></span>
      </div>
      </>
    )
  }
}

export default withRouter(LanguageDropdown);